import { render, staticRenderFns } from "./updatePartnerBankInfoCp.vue?vue&type=template&id=1ee6a5c6"
import script from "./updatePartnerBankInfoCp.vue?vue&type=script&lang=js"
export * from "./updatePartnerBankInfoCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports